import { render, staticRenderFns } from "./Ordini.vue?vue&type=template&id=662e3410"
import script from "./Ordini.vue?vue&type=script&lang=js"
export * from "./Ordini.vue?vue&type=script&lang=js"
import style0 from "./Ordini.vue?vue&type=style&index=0&id=662e3410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports